import { createFileRoute, Link } from '@tanstack/react-router'
import { Snowflake, Wrench, Zap, Bug, Sparkles, Hammer, Refrigerator, Truck, Search, Plus } from 'lucide-react'
import { useT, type MessageKey } from '@/i18n'
import { firstNameOf, useProfile } from '@/lib/account'

// Spec 002, linked to search in spec 004. The categories are the ones the product specification
// names for the launch city.
export const Route = createFileRoute('/_client/home')({ component: ClientHome })

const CATEGORIES: Array<{ key: MessageKey; slug: string; icon: typeof Wrench }> = [
  { key: 'cat.aircon', slug: 'aircon', icon: Snowflake },
  { key: 'cat.plumbing', slug: 'plumbing', icon: Wrench },
  { key: 'cat.electrical', slug: 'electrical', icon: Zap },
  { key: 'cat.pest', slug: 'pest', icon: Bug },
  { key: 'cat.cleaning', slug: 'cleaning', icon: Sparkles },
  { key: 'cat.carpentry', slug: 'carpentry', icon: Hammer },
  { key: 'cat.appliance', slug: 'appliance', icon: Refrigerator },
  { key: 'cat.moving', slug: 'moving', icon: Truck },
]

function ClientHome() {
  const { t } = useT()
  const profile = useProfile()
  const name = firstNameOf(profile.data?.display_name)

  return (
    <div className="space-y-6">
      <h1 className="font-display text-[22px] font-bold leading-tight tracking-[-0.02em] text-token-primary">
        {t('home.greeting', { name })}
      </h1>
      <div className="grid gap-3 sm:grid-cols-2">
        <Link to="/search" className="flex items-center gap-2 rounded-[12px] border border-token-subtle bg-token-surface px-4 py-3 text-[14px] font-semibold text-token-primary hover:border-token-strong">
          <Search className="h-4 w-4 text-brand" />{t('search.title')}
        </Link>
        <Link to="/tasks/new" className="flex items-center gap-2 rounded-[12px] bg-brand px-4 py-3 text-[14px] font-semibold text-brand-fg hover:bg-brand-hover">
          <Plus className="h-4 w-4" />{t('tasks.post')}
        </Link>
      </div>
      <section>
        <h2 className="mb-3 text-[13px] font-bold uppercase tracking-[0.06em] text-token-muted">{t('home.categories')}</h2>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          {CATEGORIES.map((c) => (
            <Link key={c.key} to="/search" search={{ category: c.slug }} className="flex flex-col items-start gap-2 rounded-[14px] border border-token-subtle bg-token-surface p-4 transition-colors hover:border-token-strong">
              <span className="flex h-9 w-9 items-center justify-center rounded-[10px] bg-token-selected text-brand"><c.icon className="h-5 w-5" /></span>
              <span className="text-[14px] font-semibold text-token-primary">{t(c.key)}</span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  )
}
